import { render } from "./payment-links.vue?vue&type=template&id=04b08744"
import script from "./payment-links.vue?vue&type=script&lang=js"
export * from "./payment-links.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__